import { render, staticRenderFns } from "./pesertabmtk.vue?vue&type=template&id=4ccefab4"
import script from "./pesertabmtk.vue?vue&type=script&lang=js"
export * from "./pesertabmtk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports